import React from "react";
import "./AcademicsModal.css";
import MessagePanel from "../../../theme/messagePanel/MessagePanel";
import { academics } from "../../../config/constants";

const AcademicsModal = () => {
  return (
    <div className="inner-container-first academics-container">
      <div className="scrollable-inner academics-scrollable-container">
        <MessagePanel {...academics} />
      </div>
    </div>
  );
};

export default AcademicsModal;
